import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== "/login" && path !== "/" && path !== "/qr-login") {
        localStorage.removeItem("bb_token");
        localStorage.removeItem("bb_user");
        window.location.href = "/login";
      }
    }
    // Subscription / credits / feature-lock errors fire a global event so
    // RenewalModal (mounted in App.js) can pop up the QR payment popup.
    // Backend returns `detail: { code, show_renewal_qr: true, message }`
    // for these. We swallow nothing — the original promise still rejects
    // so individual screens can also show a toast if they want.
    const detail = err?.response?.data?.detail;
    if (
      detail &&
      typeof detail === "object" &&
      (detail.show_renewal_qr === true ||
        detail.code === "trial_exhausted" ||
        detail.code === "credits_exhausted" ||
        detail.code === "feature_locked" ||
        detail.code === "subscription_expired" ||
        detail.code === "subscription_blocked")
    ) {
      try {
        window.dispatchEvent(
          new CustomEvent("brandborn:show-renewal", {
            detail: {
              code: detail.code,
              message: detail.message,
              feature: detail.feature,
            },
          })
        );
      } catch {
        /* SSR / older browsers — ignore */
      }
    }
    return Promise.reject(err);
  }
);

export function getToken() {
  return localStorage.getItem("bb_token");
}

export function setAuth(token, user) {
  localStorage.setItem("bb_token", token);
  localStorage.setItem("bb_user", JSON.stringify(user));
}

export function getUser() {
  try {
    const raw = localStorage.getItem("bb_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function logout() {
  localStorage.removeItem("bb_token");
  localStorage.removeItem("bb_user");
  window.location.href = "/login";
}

// Normalize any FastAPI/axios error into a plain string for toasts.
export function errMsg(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    // Pydantic validation errors: [{type, loc, msg, input, ctx}, ...]
    return d.map((e) => e?.msg || JSON.stringify(e)).join("; ");
  }
  if (typeof d === "object") {
    return d.message || d.code || JSON.stringify(d);
  }
  return fallback;
}
